import Korto from "./korto"

const Fonts = {
  Korto,
}

export default Fonts
